<template>
    <div class="body_main">
        <div class="body_bd">
            <!-- 搜索-->
            <el-form class="search_con" :model="queryOrderParams" ref="queryOrderParamsForm" :inline="true"
                     label-width="100px" @submit.prevent="getOrderList">
                <el-form-item label="就诊单号">
                    <el-input style="width: 140px"
                        ref="serialNoInput"
                        v-model="queryOrderParams.serialNo"
                        placeholder="就诊单号"
                        clearable
                        @keydown.enter.prevent
                        @keyup.enter="searchOrderByBarcode"
                    />
                </el-form-item>
                <el-form-item label="就诊单状态">
                    <el-select style="width: 120px" v-model="queryOrderParams.status" placeholder="就诊单状态">
                        <el-option label="待支付" value="3"></el-option>
                        <el-option label="待配送" value="5"></el-option>
                        <el-option label="待煎煮" value="11"></el-option>
                        <el-option label="待取药" value="12"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="就诊医生">
                    <el-input style="width: 120px"
                        v-model="queryOrderParams.doctorName"
                        placeholder="就诊医生"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="患者姓名">
                    <div class="width100 posi_rela">
                        <el-input style="width: 140px" v-model="queryOrderParams.patientName" placeholder="患者姓名" clearable @input="queryPatiantListByName"></el-input>
                        <div class="name_select_con" v-if="nameSelectConShow">
                            <div :class="item.isChoose ? 'name_select_li name_select_li_act flex_c_between':'name_select_li flex_c_between'"
                                 v-for="(item, index) in patientRange" :key="index" @click="sureChoosePatient(item.dppId, item.name)">
                                <div style="float: left">
                                    <span class="font_w" >{{ item.name }}</span>
                                    <span class="mrl10" style="color: var(--el-text-color-secondary); font-size: 13px;">
                                            <span>{{ item.sex }}</span>
                                            <span class="mrl10">{{ item.age }}岁</span>
                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="患者身份证">
                    <el-input style="width: 140px"
                        v-model="queryOrderParams.identity"
                        placeholder="身份证号码"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="患者手机号">
                    <el-input style="width: 140px"
                        v-model="queryOrderParams.phoneNumber"
                        placeholder="手机号码"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="开方日期">
                    <el-date-picker
                        v-model="dateTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="YYYY-MM-DD"
                        @change="chooseDateTime($event)"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button class="mrl20" plain type="primary" icon="Search" native-type="submit">搜索</el-button>
                    <el-button class="mrl20" plain type="info" icon="RefreshLeft" @click="resetQuery">重置</el-button>
                    <el-button class="mrl10" plain type="warning" icon="Refresh" :loading="orderTableLoading" @click="getOrderList">刷新待支付列表</el-button>
                </el-form-item>
            </el-form>
            <div class="pending-order-reminder" role="status" aria-live="polite">
                <el-tag type="warning" effect="dark" disable-transitions>待支付订单：{{ pendingOrderCount === null ? '暂不可用' : `${pendingOrderCount} 张` }}</el-tag>
                <span>收费后或关闭收费窗口后列表会自动刷新；同一患者的同批多张处方使用相同浅色，不同患者以不同浅色区分。请结合“同批 / 待付”数量核对后收款。</span>
            </div>

            <!-- 表格-->
            <div class="table_bd">
                <el-table
                    ref="multipleOrderTable"
                    v-loading="orderTableLoading"
                    :data="orderlist"
                    :row-class-name="getOrderRowClassName"
                    :row-style="getOrderRowStyle"
                    :height="orderTableHeight"
                    @row-dblclick="dbclickOpenOrderDetail"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column
                        width="65px"
                        fixed
                        align="center"
                        label="序号">
                        <template #default="scope">
                            <div class="flex_c">
                                {{ scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="就诊单号"
                        fixed
                        width="200px">
                        <template #default="scope">
                            <el-tag class="mrr5" size="small" effect="dark"
                                    :type="scope.row.orderSource === 'patient' || scope.row.orderSource === 'patientRepeat' ? 'warning' :
                                    scope.row.orderSource === 'doc' || scope.row.orderSource === 'docRepeat' ? 'success' : 'primary'"
                                    disable-transitions>{{
                                    scope.row.orderSource === 'patient' || scope.row.orderSource === 'patientRepeat' ? '患' :
                                        scope.row.orderSource === 'doc' || scope.row.orderSource === 'docRepeat' ? '医' : '门'
                                }}
                            </el-tag>
                            <el-tag class="mrr5" size="small" effect="light" :type="scope.row.isFree === '1' ? '' : 'info'"
                                    disable-transitions>{{ scope.row.isFree === '1' ? '普' : '科' }}
                            </el-tag>
                            <el-tag class="mrr5" size="small" effect="plain"
                                    v-if="scope.row.orderSource === 'patientRepeat' || scope.row.orderSource === 'docRepeat'"
                                    type="danger">复
                            </el-tag>
                            <el-tag class="mrr5" size="small" effect="light"
                                    :type="scope.row.billingType === '0' ? 'primary' : scope.row.billingType === '1' ? 'success' : scope.row.billingType === '2' ? 'warning' : 'danger'"
                                    disable-transitions>{{ scope.row.billingTypeName === null || scope.row.billingTypeName === undefined ? '' :scope.row.billingTypeName.substr(0, 1) }}
                            </el-tag>
                            <el-tag class="mrr5" size="small" type="success"
                                    v-if="scope.row.billingType === '1'&&scope.row.decoctType === '0'">自煎
                            </el-tag>
                            <el-tag class="mrr5" size="small" type="warning"
                                    v-if="scope.row.billingType === '1'&&scope.row.decoctType === '1'">代煎
                            </el-tag>
                            <br>
                            <span>{{ scope.row.serialNo === null ? '---' : scope.row.serialNo }}</span>
                            <div
                                v-if="scope.row.prescriptionGroupId && scope.row.prescriptionGroupCount > 1 && scope.row.prescriptionGroupWaitPayCount > 0"
                                class="prescription-batch-summary">
                                同批{{ scope.row.prescriptionGroupCount }}张 / 待付<strong>{{ scope.row.prescriptionGroupWaitPayCount }}张</strong>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="患者姓名"
                        fixed
                        width="140px">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image style="width: 32px;height: 32px;margin-right: 10px"
                                          :src="scope.row.patientAvatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 14px; font-weight: 600; line-height: 22px">{{
                                            scope.row.patientName === null ? '---' : scope.row.patientName
                                        }}</span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{
                                            scope.row.patientSexText
                                        }} {{ scope.row.patientAge }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="140px"
                        label="手机号">
                        <template #default="scope">
                            <div class="span_con">
                                {{
                                    maskOrderPhone(scope.row.patientPhone)
                                }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="170px"
                        label="身份证">
                        <template #default="scope">
                            <div class="span_con">
                                {{
                                    maskOrderIdentity(scope.row.patientIdentity)
                                }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="120px"
                        label="订单状态">
                        <template #default="scope">
                            <div class="span_con">
                                <el-tag class="mrr5" size="small" :type="scope.row.status === '3' || scope.row.status === '4' || scope.row.status === '10' ? 'danger' :
                                scope.row.status === '1' || scope.row.status === '5' || scope.row.status === '6' || scope.row.status === '7' ? 'primary' :
                                scope.row.status === '2' || scope.row.status === '9' ? 'warning' :
                                scope.row.status === '7' ? 'success' : 'info'"
                                        disable-transitions>{{ getOrderStatus(scope.row.status) }}
                                </el-tag>

                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="90px"
                        label="开方医生">
                        <template #default="scope">
                            <div class="span_con">
                                {{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        width="160px"
                        label="开方时间">
                    </el-table-column>
                    <el-table-column
                        width="120px"
                        label="总费用（元）">
                        <template #default="scope">
                            <span class="order-total-amount">{{ formatOrderListNumber(scope.row.orderPrice) }}</span>
                        </template>
                    </el-table-column>
                    <!-- 费用明细列暂时隐藏，保留字段和列定义便于后续恢复。 -->
                    <el-table-column
                        v-if="false"
                        width="120px"
                        label="药材费用">
                        <template #default="scope">
                            <span class="font_blue">￥{{
                                    scope.row.medicalCountPrice === null || scope.row.medicalCountPrice === undefined ? '0.00' : scope.row.medicalCountPrice
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="false"
                        width="120px"
                        label="加工费用">
                        <template #default="scope">
                            <span>￥{{
                                    scope.row.processingCosts === null || scope.row.processingCosts === undefined ? '0.00' : scope.row.processingCosts
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="120px"
                        label="药方总重（g）">
                        <template #default="scope">
                            <span>{{ formatOrderListNumber(scope.row.orderWeight) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="280px"
                        label="诊断结果">
                        <template #default="scope">
                            <div class="span_con"
                                 :title="scope.row.clinicalDiagnosis === null ? '---' : scope.row.clinicalDiagnosis">
                                {{ scope.row.clinicalDiagnosis === null ? '---' : scope.row.clinicalDiagnosis }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="160px"
                        label="用法">
                        <template #default="scope">
                                <span class="span_con"
                                      :title="scope.row.instructions === null ? '---' : scope.row.instructions">{{
                                        scope.row.instructions === null ? '---' : scope.row.instructions
                                    }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="160px"
                        label="关联药房">
                        <template #default="scope">
                            <span>{{
                                    scope.row.doctorName === '' || scope.row.doctorName === null ? '中药房' : '中药房'
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="160px"
                        label="地址">
                        <template #default="scope">
                                <span class="span_con"
                                      :title="scope.row.receiveDetail === null ? '---' : scope.row.receiveDetail">{{
                                        scope.row.receiveDetail === null ? '---' : scope.row.receiveDetail
                                    }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注">
                        <template #default="scope">
                            <div class="span_con" :title="scope.row.remark === null ? '---' : scope.row.remark">
                                {{ scope.row.remark === null ? '---' : scope.row.remark }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="180px">
                        <template #default="scope">
                            <div class="order-row-actions">
                                <el-button v-if="scope.row.status === '3'" type="danger" size="small"
                                           @click="openListPayment(scope.row)">收费</el-button>
                                <el-button type="success" size="small"
                                           @click="openOrderDetail(scope.row.orderId,scope.row.status)">详情</el-button>
                                <el-button v-if="scope.row.status !== '3'" type="primary" size="small"
                                           @click="printListReceipt(scope.row)">打印凭证</el-button>
                                <!-- 只读查询收款结果，不发起扣款。 -->
                                <el-button v-if="scope.row.status === '3'" type="warning" size="small"
                                           @click="queryListPayResult(scope.row)">查收款</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleOrderSizeChange"
                    @current-change="handleOrderCurrentChange"
                    :current-page="currentPageOrder"
                    :page-size="pageNumsOrder"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCountOrder">
                </el-pagination>
            </div>

        </div>
    </div>

    <!--订单详情-->
    <el-drawer :with-header="false" v-model="orderDetailDialogVisible" :direction="direction" destroy-on-close
               size="36%"
               style="background: #f5f7fa">
        <div class="drawer_con">
            <div class="drawer_title">
                <span>订单详情</span>
                <el-icon class="drawer_icon" @click="orderDetailDialogVisible = false">
                    <close-bold/>
                </el-icon>
            </div>

            <Orderdetail :orderId="orderId" @order-updated="refreshOrderListSilently"></Orderdetail>
        </div>
    </el-drawer>
    <!-- 独立收费入口不挂载在详情抽屉内，沿用相同收费与无感刷新链路。 -->
    <Orderdetail v-if="listPaymentOrderId" :key="listPaymentKey" :order-id="listPaymentOrderId"
                 payment-only @order-updated="refreshOrderListSilently"
                  />
    <Orderdetail v-if="listPrintOrderId" :key="`print-${listPrintKey}`" :order-id="listPrintOrderId"
                 print-only @order-updated="refreshOrderListSilently" />

</template>

<script>
import order from "@/assets/scripts/order/index";

export default order;
</script>

<style scoped>
@import "@/assets/styles/style.scss";


.order-total-amount {
    color: var(--el-color-danger-dark-2, #c45656);
    font-weight: 700;
    font-variant-numeric: tabular-nums;
}

/* 操作列保留紧凑实底文字按钮，不增加列表行高。 */
.order-row-actions {
    display: flex;
    align-items: center;
    gap: 5px;
}
.order-row-actions :deep(.el-button) {
    height: 24px;
    margin: 0;
    padding: 0 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
}

.pending-order-reminder {
    display: flex;
    align-items: center;
    gap: 10px;
    box-sizing: border-box;
    min-height: 36px;
    margin: 0 0 6px;
    padding: 4px 10px;
    border: 1px solid #f3d19e;
    border-radius: 4px;
    background: #fdf6ec;
    color: #7c4a03;
    font-size: 13px;
}

.pending-order-reminder > span {
    min-width: 0;
    line-height: 20px;
    overflow-wrap: anywhere;
}
.pending-order-reminder :deep(.el-tag) {
    flex-shrink: 0;
    height: 24px;
    line-height: 22px;
}

:deep(.el-table tr.prescription-group-pending) {
    --el-table-tr-bg-color: var(--prescription-group-bg);
    --el-table-row-hover-bg-color: var(--prescription-group-hover);
}

:deep(.el-table tr.prescription-group-pending > td.el-table__cell) {
    background: var(--prescription-group-bg);
    transition: background-color 0.15s ease;
}

:deep(.el-table tr.prescription-group-pending:hover > td.el-table__cell),
:deep(.el-table tr.prescription-group-pending.hover-row > td.el-table__cell),
:deep(.el-table tr.prescription-group-pending.current-row > td.el-table__cell) {
    background: var(--prescription-group-hover);
}

/* 左侧色条辅助扫读；固定列与普通单元格保持相同的底色。 */
:deep(.el-table tr.prescription-group-pending > td.el-table__cell:first-child) {
    border-left: 3px solid var(--prescription-group-accent);
}

:deep(.prescription-batch-summary) {
    display: flex;
    align-items: center;
    gap: 6px;
    width: fit-content;
    margin-top: 5px;
    padding: 2px 6px;
    border: 1px solid var(--prescription-group-accent);
    border-radius: 4px;
    color: var(--el-text-color-regular);
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
}

:deep(.prescription-batch-summary strong) {
    color: var(--el-color-warning-dark-2);
    font-weight: 600;
}
</style>
